const Alert = {
  variants: {
    solid: (props: { colorScheme?: string }) => {
      if (props.colorScheme === "red") {
        return {
          container: {
            bg: "red.500",
            color: "white",
          },
          title: { color: "white" },
          description: { color: "white" },
          icon: { color: "white" },
        };
      }
      return {};
    },
  },
};

export default Alert;
